import { createAction } from '@reduxjs/toolkit';
import EcomEngineAPI from 'api/ecom_engine_api';
import { trackError } from 'utils/helpers';

const createAccomodationReservationStarted = createAction(
  'reservation/createAccomodationReservationStarted'
);
const createAccomodationReservationSucceeded = createAction(
  'reservation/createAccomodationReservationSucceeded'
);
const createAccomodationReservationFailure = createAction(
  'reservation/createAccomodationReservationFailure'
);

const createAccomodationReservation = (values) => (dispatch) => {
  dispatch(createAccomodationReservationStarted());

  return EcomEngineAPI.reservation
    .createAccomodation(values)
    .then((json) => {
      dispatch(createAccomodationReservationSucceeded(json));
      return json;
    })
    .catch((error) => {
      trackError(error);
      dispatch(createAccomodationReservationFailure(error.message));
      return Promise.reject(error);
    });
};

export {
  createAccomodationReservationStarted,
  createAccomodationReservationSucceeded,
  createAccomodationReservationFailure,
  createAccomodationReservation,
};
